export const ENV = process.env.NODE_ENV

const DOMAIN = process.env.API_DOMAIN

export const MSG_SUPPORT = process.env.MSG_SUPPORT
export const DATE_SUPPORT = process.env.DATE_SUPPORT
export const TIME_SUPPORT = process.env.TIME_SUPPORT

export const GF_APIKEY = process.env.GF_APIKEY
export const GF_AUTHDOMAIN = process.env.GF_AUTHDOMAIN
export const GF_PROJECTID = process.env.GF_PROJECTID
export const GF_STORAGEBUCKET = process.env.GF_STORAGEBUCKET
export const GF_MESSAGINGSENDERID = process.env.GF_MESSAGINGSENDERID
export const GF_APPID = process.env.GF_APPID
export const GF_MEASUREMENTID = process.env.GF_MEASUREMENTID
export const GF_PUBLIC_VAPID_KEY = process.env.GF_PUBLIC_VAPID_KEY
export const SENTRY_ENV = process.env.SENTRY_ENV
export const TOKEN_GROWTHBOOK = process.env.TOKEN_GROWTHBOOK

export const API_DOMAIN = SENTRY_ENV !== 'production' ? `https://api-qa.${DOMAIN}/` : `https://api.${DOMAIN}/`

/*// Pruebas*/
export const PAYU_LINK = 'http://sandbox.api.payulatam.com/payments-api/4.0/service'
/*// Produccion
// export const PAYU_LINK = 'http://api.payulatam.com/payments-api/4.0/service'*/


export const SENTRY_URL = process.env.SENTRY_URL

export const COMING_CHECKOUT_SSE_ENABLED =
  process.env.COMING_CHECKOUT_SSE_ENABLED === 'true'


export const TENANT = process.env.TENANTID
export const AUTH365_CLIENT = process.env.AUTH365_CLIENT_ID
export const PORT = process.env.PORT

const HOST = ENV === 'development' ? 'localhost' : DOMAIN

export const COOKIE_DOMAIN = HOST
export const PLATFORMS_LINKS = HOST

export const getUrl = (platform) => {
    switch (ENV) {
        case 'development':
            return platform
        default:
            return `https://${platform}.${DOMAIN}`
    }
}

export const getPlatformLink = platform => {
    if (platform === 'miadvenio') {
        return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:${process.env.PORT}` : SENTRY_ENV !== 'production' ? `https://qa.${PLATFORMS_LINKS}` : `https://app.${PLATFORMS_LINKS}`
    }
    if (platform === 'hr') {
        return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:${process.env.PORT}` : SENTRY_ENV !== 'production' ? `https://rh-qa.${PLATFORMS_LINKS}` : `https://rh.${PLATFORMS_LINKS}`
    }
    if (platform === 'companies' && SENTRY_ENV !== 'production') {
        return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:${process.env.PORT}` : `https://empresas-dev.${PLATFORMS_LINKS}`
    }

    return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:${process.env.PORT}` : SENTRY_ENV !== 'production' ? `https://${platform}-qa.${PLATFORMS_LINKS}` : `https://${platform}.${PLATFORMS_LINKS}`
}

export const CONEKTA_PUBLIC_KEY = process.env.CONEKTA_PUBLIC_KEY
export const CONEKTA_PUBLIC_ADV_KEY = process.env.CONEKTA_PUBLIC_ADV_KEY
export const CONEKTA_PUBLIC_EAM_KEY = process.env.CONEKTA_PUBLIC_EAM_KEY
export const SR_PAGO_PUBLIC_KEY = 'pk_dev_5b96ae2346959M4=?T'
export const PAYU_PUBLIC_KEY = process.env.PAYU_PUBLIC_KEY
export const PAYU_ACCOUNT_ID = process.env.PAYU_ACCOUNT_ID



// WEBPACK FOOTER //
// ./src/config.js